export default __webpack_public_path__ + "static/megaball-d38cd91728aeea4375d7535fb52a6b84.png";